import { render, staticRenderFns } from "./ContactInformationContactForm.vue?vue&type=template&id=2bcea461&scoped=true&"
import script from "./ContactInformationContactForm.vue?vue&type=script&lang=ts&"
export * from "./ContactInformationContactForm.vue?vue&type=script&lang=ts&"
import style0 from "./ContactInformationContactForm.vue?vue&type=style&index=0&id=2bcea461&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bcea461",
  null
  
)

export default component.exports